import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const getPk = (orderDetail) => {
  return api.post(`${ApiEndpointConstants.GETPK}`, {
    data: JSON.stringify(orderDetail),
  });
};

export const getUrl = (orderDetail) => {
  return api.post(`${ApiEndpointConstants.GET_URL}`, {
    data: JSON.stringify(orderDetail),
  });
};
